// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2b61e8f6","455":"d736f18f","977":"0d035344"}[chunkId] + ".chunk.js";
};